import { render, staticRenderFns } from "./ReportQuacks.vue?vue&type=template&id=4a0ff295"
import script from "./ReportQuacks.vue?vue&type=script&lang=js"
export * from "./ReportQuacks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports